import React from 'react'

import exterior from './../../../UI/canvas/CarMenu/btns/exterior.svg'
import exteriorSelected from './../../../UI/canvas/CarMenu/btns/exterior-selected.svg'
import interior from './../../../UI/canvas/CarMenu/btns/interior.svg'
import interiorSelected from './../../../UI/canvas/CarMenu/btns/interior-selected.svg'

import back from './../../../UI/canvas/CarMenu/btns/back-btn.svg'

import close from './../../../UI/canvas/CarMenu/btns/Close.svg'

import { modelsData } from '../../../data/models.data'

interface Props {
  isThreeActive: boolean,
  handleSelectedMenuElement: any,
  handleSetAccessoriesSelected: any,
  currentAccessoriesSelected: any,
  currentColorSelected: any,
  handleSetColor: any,
  handleOpenTerms: any,
  carSelected: string,
  isInterior: boolean
}

interface State {
  currentVistaSelected: number,
  selectedCar: string,
  currentColorIndexSelected: number,
  currentAccessoriesSet: any,
  currentAccesorieOpened: any
}

class AccesssoriesContainer extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      currentVistaSelected: 0,
      selectedCar: "",
      currentColorIndexSelected: 0,
      currentAccessoriesSet: {},
      currentAccesorieOpened: []
    }
  }

  componentDidMount(): void {


    let accessoriesObject = {}
    let initalAccesoriosSelected: any = []
    let accessories = {}

    this.setState({
      selectedCar: this.props.carSelected
    }, () => {

    if(modelsData()[0][this.state.selectedCar]){
      modelsData()[0][this.state.selectedCar].accesories.map((accessory: any) => {
        accessories[accessory.name] = accessory.name.includes('BDM') ? 1:0
        if(accessoriesObject.hasOwnProperty(accessory.section)){
          accessoriesObject[accessory.section].push(accessory)
        }
        else {
          accessoriesObject[accessory.section] = [accessory]
        }
        return 0
      })
  
      this.setState({
        currentAccessoriesSet: accessoriesObject
      }, () => {
        this.props.handleSetAccessoriesSelected(accessories, '')
        this.props.handleSetColor(modelsData()[0][this.state.selectedCar].colors[0])
      })
    }



    })

    
  }

  handleAddAccessorie = (accessory) => {
    let tempAccessories =  this.props.currentAccessoriesSelected
    tempAccessories[accessory.name] = tempAccessories[accessory.name] === 1 ? 0:1
    if(tempAccessories[accessory.name] === 0){
      if(accessory.enableOnDisable){
        accessory.enableOnDisable.map((accesoryToShow: any) => {
          tempAccessories[accesoryToShow] = 1
          return 0
        }) 
      }
    }
    if(accessory.hide && tempAccessories[accessory.name] === 1){
      accessory.hide.map((hiddenAccessory: any) => {
        tempAccessories[hiddenAccessory] = 0
        return 0
      })
    }
    this.props.handleSetAccessoriesSelected(tempAccessories, accessory)
  }

  handleChangeColor = (color: any, index: number) => {
    this.setState({
      currentColorIndexSelected: index
    }, () => {
      this.props.handleSetColor(color)
    })
  }

  handleAddToArray = (index: number) => {
    var tempArray = this.state.currentAccesorieOpened
    if(tempArray.includes(index)){
      tempArray.splice(tempArray.indexOf(index),1)
    }
    else{
      tempArray.push(index)
    }
    this.setState({
      currentAccesorieOpened: tempArray
    })
  }


  render(): React.ReactNode {
      return(
        this.state.selectedCar !== '' ?
        <div className='accessories-module-container'>
          <div className='accessories-general-container'>
            <div className='accessories-vista-container'>
              <div className='accesories-vista-title'>VISTAS</div>
              <div className='accessories-vista-btns-container'>
                <div 
                data-value={"exterior"} data-type={"INTERFAZ"}
                className={this.state.currentVistaSelected === 0 ? 'accesories-vista-btn-selected':'accesories-vista-btn'}
                onClick={() => {
                  this.setState({
                    currentVistaSelected: 0
                  })
                  this.props.handleSelectedMenuElement(3,'customize',-1)
                }}
                >
                  <img src={!(this.state.currentVistaSelected === 0) ? exteriorSelected:exterior} alt=''/>
                  <div>Exterior</div>
                </div>
                <div 
                data-value={"interior"} data-type={"INTERFAZ"}
                className={this.state.currentVistaSelected === 1 ? 'accesories-vista-btn-selected':'accesories-vista-btn'} 
                onClick={() => {
                  this.setState({
                    currentVistaSelected: 1
                  })
                  this.props.handleSelectedMenuElement(3,'customize',1)
                }}
                >
                  <img src={!(this.state.currentVistaSelected === 1) ? interiorSelected:interior} alt=''/>
                  <div>Interior</div>
                </div>
              </div>
            </div>

            <hr/>

            {this.props.isInterior === false && modelsData()[0][this.state.selectedCar].colors.length > 0 ?
              <React.Fragment>
                <div className='accesories-colors-container'>
                  <div className='accessories-colors-title'>COLORES</div>
                  <div className='accessories-colors-btns-container' style={{
                    justifyContent: modelsData()[0][this.state.selectedCar].colors.length <= 4 ? 'center':'flex-start'
                  }}>
                    {modelsData()[0][this.state.selectedCar] ?
                      modelsData()[0][this.state.selectedCar].colors.map((color: any, index: number) => 
                        <div className={this.state.currentColorIndexSelected === index ? 'accessories-color-btn-selected':'accessories-color-btn'} id='element-umbra-analytics' data-second={color.Name} data-value={this.state.selectedCar} data-type={"COLOR"} onClick={() => {
                          this.handleChangeColor(color, index)
                        }}>
                          <img id='element-umbra-analytics' data-second={color.Name} data-value={this.state.selectedCar} data-type={"COLOR"} src={color.Image} alt=""/>
                        </div>
                      ):null
                    }
                  </div>
                  <div className='accessories-current-color-name'>{modelsData()[0][this.state.selectedCar].colors[this.state.currentColorIndexSelected].Name}</div>
                </div>

                <hr/>
              </React.Fragment>:null
            }

            {
              this.props.carSelected !== 'MUSTANG MACH 1' 
              && this.props.carSelected !== 'EDGE ST' 
              && this.props.carSelected !== 'EDGE SEL' 
              && this.props.carSelected !== 'EXPLORER ST'
              && this.props.carSelected !== 'EXPEDITION LIMITED'
              && this.props.carSelected !== 'RANGER FX4' 
              && this.props.carSelected !== 'RANGER LIMITED BLACK EDITION' 
              && this.props.carSelected !== 'F-150 XLT FHEV' 
              && this.props.isInterior === false ?
              <div className='accessories-container'>
              <div className='accessories-title'>ACCESORIOS</div>
              <div className='accesories-categoty-container'>
                {
                  Object.keys(this.state.currentAccessoriesSet).map((category: any, index: number) => 
                  {
                    let currentAccessoriesSelected: Array<string> = []
                    this.state.currentAccessoriesSet[category].map((model: any) => 
                    {
                      if( this.props.currentAccessoriesSelected[model.name] === 1 && !model.name.includes('BDM')){
                        currentAccessoriesSelected.push(model.showroom)
                      }
                      return 0
                    }
                    )

                    return(
                      <div className='accessories-category-individual-container' key={category+index}>
                        <div className='accessories-category-inidivual-title' onClick={() => {this.handleAddToArray(index)}} style={{cursor: 'pointer'}}>
                          <div>{category}</div>
                          <img src={back} alt=""/>
                        </div>
                        {
                          this.state.currentAccesorieOpened.includes(index) ?
                          <div className='accessorioes-category-thumbs-container'>
                          {
                            this.state.currentAccessoriesSet[category].map((model: any, index: any) => 
                              !model.name.includes('BDM') ?
                              <React.Fragment>
                                <div id='element-umbra-analytics' data-second={model.showroom} data-value={this.props.carSelected} data-type={"ACCESORIO"} className={this.props.currentAccessoriesSelected[model.name] === 1 ? 'accessories-complete-selected':'accessories-complete'} onClick={() => {this.handleAddAccessorie(model)}}>
                                  <img id='element-umbra-analytics' data-second={model.showroom} data-value={this.props.carSelected} data-type={"ACCESORIO"}  src={model.Image} alt="" className='accessorie-thumb'/>
                                  <div id='element-umbra-analytics' data-second={model.showroom} data-value={this.props.carSelected} data-type={"ACCESORIO"}  className='accessories-complete-name'>
                                    {
                                      model.showroom
                                    }
                                  </div>
                                  {
                                  this.props.currentAccessoriesSelected[model.name] === 1 ?
                                  <div className='delete-btn-accessories'>
                                    <img src={close} alt=''/>
                                  </div>:null
                                }
                                </div>
                                
                              </React.Fragment>:null
                            )
                          }
                        </div>:null
                        }
                        {/*
                          currentAccessoriesSelected.length > 0 ?
                          <div className='selected-accessories-section'>
                            <div className='selected-accessories-title'>Estás viendo:</div>
                            <div className='selected-accessories-text'>
                              {
                                currentAccessoriesSelected.join(', ')
                              }
                            </div>
                          </div>:null
                          */}
                        <hr/>
                      </div>
                    )
                  }
                  )
                }
              </div>
            </div>:null
            }
          </div>
          <div className='accessories-terms-btn-container'>
            <div className='accessories-terms-btn' onClick={() => {this.props.handleOpenTerms()}}>
              Condiciones y restricciones
            </div>
          </div>
        </div>:null
      )
  }
}

export default AccesssoriesContainer